import { memo, useContext } from 'react';
import { ConfigContext } from 'src/configContext';
import { I18n } from 'src/modules/common/components/I18n/I18n';
import { MESSAGES } from 'src/modules/common/constants';
import { WarningCircleFilledIcon } from 'src/modules/common/icons/WarningCircleFilledIcon';

export const ActuatorHomeInfo = memo(() => {
    const { userSettings } = useContext(ConfigContext);

    return (
        <div className="vss-actuator-home-info">
            <div className="vss-actuator-home-info__icon">
                <WarningCircleFilledIcon/>
            </div>

            <div className="vss-actuator-home-info__content">
                <div className="vss-actuator-home-info__title">
                    <I18n messageId={MESSAGES.ActuatorHomeInfoTitle}/>
                </div>

                <div className="vss-actuator-home-info__body">
                    <ul className="vss-actuator-home-info__list">
                        <li className="vss-actuator-home-info__row">
                            <I18n messageId={MESSAGES.ActuatorHomeInfo1}/>
                                &nbsp;
                            <a
                                href={`https://www.belimo.com/${
                                    userSettings.currentCountry.toLowerCase()
                                }/${
                                    userSettings.currentLocale
                                }/products/retrofit-app.html`}
                                target="_blank"
                                rel="noreferrer"
                            >
                                <I18n messageId={MESSAGES.ActuatorHomeInfoLink}/>
                            </a>
                        </li>

                        <li className="vss-actuator-home-info__row">
                            <I18n messageId={MESSAGES.ActuatorHomeInfo2}/>
                        </li>
                    </ul>

                    <ul className="vss-actuator-home-info__list">
                        <li className="vss-actuator-home-info__row">
                            <I18n messageId={MESSAGES.ActuatorHomeInfo3}/>
                        </li>

                        <li className="vss-actuator-home-info__row">
                            <I18n messageId={MESSAGES.ActuatorHomeInfo4}/>
                        </li>

                        <li className="vss-actuator-home-info__row">
                            <I18n messageId={MESSAGES.ActuatorHomeInfo5}/>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
});
